/**成交订单 */
export default{
    name: 'success',
    path: 'success',
    meta: { title: '成交订单' },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'success-index',
            path: 'index',
            meta: { title: '成交订单' },
            component: ()=>import('@/pages/success/index.vue')
        },
        {
            name: 'success-refund',
            path: 'refund',
            meta: { title: '退款订单' },
            component: ()=>import('@/pages/success/refund.vue')
        }
    ]
}
